import { render } from "./Span.vue?vue&type=template&id=03f6ceed&scoped=true"
import script from "./Span.vue?vue&type=script&lang=ts"
export * from "./Span.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-03f6ceed"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
